import Vue from 'vue'
import Vuex from 'vuex'
import { setItem, getItem } from '@/utils/storage.js'

Vue.use(Vuex)

const TOKEN_DISPATCH = 'DISPATCH'
const TOKEN_VERSION = 'VERSION'
const TOKEN_ICCD = 'ICCD'
const TOKEN_ORDER = 'ORDER'
const TOKEN_OPENID = 'OPENID'
const TOKEN_FLAG = 'FLAG'
const TOKEN_TYPE = 'TYPE'
const TOKEN_FINDTYPE = 'FINDTYPE'
const TOKEN_INITCODE = 'INITCODE'
const TOKEN_INITTOKEN = 'INITTOKEN'
const TOKEN_USERID = 'USERID'
const TOKEN_ISAUTO = 'ISAUTO'
const TOKEN_CARRIER = 'CARRIER'
const TOKEN_ACCOUNTLIST = 'ACCOUNTLIST'
const TOKEN_ISFIRST = 'ISFIRST'
const TOKEN_VERSIONPAGE = 'VERSIONPAGE'
const TOKEN_VERSIONTIME = 'VERSIONTIME'
const TOKEN_USERNAME = 'USERNAME'
const TOKEN_AGENTNAME = 'AGENTNAME'
const TOKEN_SIGNOUT = 'SIGNOUT'
const TOKEN_OFFEQP = 'OFFEQP'
const TOKEN_OVERFLOWEQP = 'OVERFLOWEQP'
const TOKEN_ISAUTOACCOUNT = 'ISAUTOACCOUNT'
const TOKEN_ACCESSTOKEN = 'ACCESSTOKEN'
const TOKEN_FIRSTLOGIN = 'FIRSTLOGIN'
export default new Vuex.Store({
  state: {
    dispatch: getItem(TOKEN_DISPATCH),
    iccd: getItem(TOKEN_ICCD),
    order: getItem(TOKEN_ORDER),
    openId: getItem(TOKEN_OPENID),
    accessToken: getItem(TOKEN_ACCESSTOKEN),
    // 充值成功与否
    flag: getItem(TOKEN_FLAG),
    // 设置是否成功还是普通状态 默认值 recharge
    type: getItem(TOKEN_TYPE),
    // 判断充值还是流量
    findType: getItem(TOKEN_FINDTYPE),
    // 初始化获取值
    initCode: getItem(TOKEN_INITCODE),
    // token
    token: getItem(TOKEN_INITTOKEN),
    // 用户ID
    userID: getItem(TOKEN_USERID),
    // 用户Name
    userName: getItem(TOKEN_USERNAME),
    // 代理商Name
    agentName: getItem(TOKEN_AGENTNAME),
    // 自动登录标识
    isAuto: getItem(TOKEN_ISAUTO),
    // 服务商
    carrier: getItem(TOKEN_CARRIER),
    // 账号列表
    accountList: getItem(TOKEN_ACCOUNTLIST),
    // 是否第一次获取
    isFirst: getItem(TOKEN_ISFIRST),
    // 版本控制
    version: getItem(TOKEN_VERSION),
    // 版本控制进行时的页面内容
    versionPage: getItem(TOKEN_VERSIONPAGE),
    // 版本控制进行时间
    versionTime: getItem(TOKEN_VERSIONTIME),
    // 是否手动退出登录了 'yes' 为手动退出
    signOut: getItem(TOKEN_SIGNOUT),
    // 已停机设备
    offEqp: getItem(TOKEN_OFFEQP),
    // 超流量设备
    overFlowEqp: getItem(TOKEN_OVERFLOWEQP),
    // 自动登录的账号
    isAutoAccount: getItem(TOKEN_ISAUTOACCOUNT),
    // 是否第一次登录
    firstLogin: getItem(TOKEN_ISAUTOACCOUNT)
  },
  mutations: {
    setDispatch (state, data) {
      state.dispatch = data
      setItem(TOKEN_DISPATCH, data)
    },
    setIccd (state, data) {
      state.iccd = data
      setItem(TOKEN_ICCD, data)
    },
    setOrder (state, data) {
      state.order = data
      setItem(TOKEN_ORDER, data)
    },
    setOpenId (state, data) {
      state.openId = data
      setItem(TOKEN_OPENID, data)
    },
    setIsAccessToken (state, data) {
      state.accessToken = data
      setItem(TOKEN_ACCESSTOKEN, data)
    },
    setFlag (state, data) {
      state.flag = data
      setItem(TOKEN_FLAG, data)
    },
    setType (state, data) {
      state.type = data
      setItem(TOKEN_TYPE, data)
    },
    setFindType (state, data) {
      state.findType = data
      setItem(TOKEN_FINDTYPE, data)
    },
    // 初始化获取值
    setInitCode (state, data) {
      state.initCode = data
      setItem(TOKEN_INITCODE, data)
    },
    // 保存token
    setToken (state, data) {
      state.token = data
      setItem(TOKEN_INITTOKEN, data)
    },
    // 保存userId
    setUserID (state, data) {
      state.userID = data
      setItem(TOKEN_USERID, data)
    },
    // 保存自动登录标识
    setIsAuto (state, data) {
      state.isAuto = data
      setItem(TOKEN_ISAUTO, data)
    },
    setCarrier (state, data) {
      state.carrier = data
      setItem(TOKEN_CARRIER, data)
    },
    setAccountList (state, data) {
      state.accountList = data
      setItem(TOKEN_ACCOUNTLIST, data)
    },
    setIsFirst (state, data) {
      state.isFirst = data
      setItem(TOKEN_ISFIRST, data)
    },
    setVersion (state, data) {
      state.version = data
      setItem(TOKEN_VERSION, data)
    },
    setVersionPage (state, data) {
      state.versionPage = data
      setItem(TOKEN_VERSIONPAGE, data)
    },
    setVersionTime (state, data) {
      state.versionTime = data
      setItem(TOKEN_VERSIONTIME, data)
    },
    setUserName (state, data) {
      state.userName = data
      setItem(TOKEN_USERNAME, data)
    },
    setAgentName (state, data) {
      state.agentName = data
      setItem(TOKEN_AGENTNAME, data)
    },
    setSignOut (state, data) {
      state.signOut = data
      setItem(TOKEN_SIGNOUT, data)
    },
    setOffEqp (state, data) {
      state.offEqp = data
      setItem(TOKEN_OFFEQP, data)
    },
    setOverFlowEqp (state, data) {
      state.overFlowEqp = data
      setItem(TOKEN_OVERFLOWEQP, data)
    },
    setIsAutoAccount (state, data) {
      state.isAutoAccount = data
      setItem(TOKEN_ISAUTOACCOUNT, data)
    },
    setFirstLogin (state, data) {
      state.firstLogin = data
      setItem(TOKEN_FIRSTLOGIN, data)
    }
  },
  actions: {
  },
  modules: {
  }
})
